import deleteIcon from "../../../../lib/assets/eventPanel/delete.svg";
import copyIcon from "../../../../lib/assets/eventPanel/copy.svg";
import disableIcon from "../../../../lib/assets/eventPanel/disable.svg";
import disdisableIcon from "../../../../lib/assets/eventPanel/disdisable.svg";
import dragIcon from "../../../../lib/assets/eventPanel/drag.svg";
import editIcon from "../../../../lib/assets/eventPanel/edit.svg";
import nextIcon from "../../../../lib/assets/eventPanel/next.svg";
import noticeIcon from "../../../../lib/assets/eventPanel/notice.svg";
import selectedIcon from "../../../../lib/assets/eventPanel/selected.svg";
import arrowDownLight from "../../../../lib/assets/eventPanel/arrow-down-light.svg";
import arrowDown from "../../../../lib/assets/eventPanel/arrow-down.svg";
export const EventPanelIcons = {
  deleteIcon,
  copyIcon,
  disableIcon,
  disdisableIcon,
  dragIcon,
  editIcon,
  nextIcon,
  noticeIcon,
  selectedIcon,
  arrowDownLight,
  arrowDown
};
//# sourceMappingURL=eventPanelIcons.js.map
